module.exports = __webpack_public_path__ + "../resources/images/illustration_search_file-6b10b7d8ed9911e504bdfd8640501ab4.svg";